{
  "decrease": "Diminuir {fieldLabel}",
  "increase": "Aumentar {fieldLabel}",
  "numberField": "Campo numérico"
}
